'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const gtm = require('./modules/google').tagManager;

function initializeCustomSelect() {
    const $select = $('select.js-custom-select');
    if (!$select.length) {
        return;
    }

    $select.each(function () {
        const $this = $(this);
        bindValidationEvents($this);
        if (skipInitialization($this)) {
            return;
        }

        $this.selectric({
            onBeforeInit: function() {
                if ($this.hasClass('js-pdp-custom-select')){
                    bindOptionsToDataAttribute($this);
                    filterVisibleOptions($this, true);
                }
            },
            onInit: function () {
                if ($this.attr('readonly')){
                    $this.attr('tabindex', '-1');
                    const $selectWrapper = $this.closest('.selectric-js-custom-select');
                    $selectWrapper.addClass('selectric-readonly');
                    $selectWrapper.find('.selectric, .selectric-input').attr('tabindex', '-1');
                }

                if ($this.hasClass('js-pdp-custom-select')) {
                    renderSelectricDropdown($this);
                    setOutOfStockClass($this);
                }
            },
            onRefresh: function() {
                if ($this.hasClass('js-pdp-custom-select')) {
                    renderSelectricDropdown($this);
                    setOutOfStockClass($this);
                }
            },
        });

        if (!isSmallView()) {
            $this.attr('tabindex', '-1');
        }
    });
}

function bindOptionsToDataAttribute(select) {
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');

    if (!$selectedSwatch.length) {
        return;
    }

    const $options = select.find('option').clone();
    $options.removeAttr('out-of-stock');
    select.data('options', $options);
}

function filterVisibleOptions(select, isFirstPass) {
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');

    if (!$selectedSwatch.length) {
        return;
    }

    const $selectedSwatchImage = $selectedSwatch.find('.js-pdp-swatches-image');
    const swatchVariationAttributeValue = $selectedSwatchImage.data('variationAttributeValue');
    const variationUrls = $selectedSwatchImage.data('variationUrls');
    const variationAttributeValues = Object.keys(variationUrls);
    const options = select.data('options').clone();
    const $selectedOption = select.children(':selected');
    let selectedOptionValue = '';
    const items = $.grep(options, function(option, index){ /* eslint-disable-line */
        option = $(option);
        const variationAttributeValue = option.data('variationAttributeValue');
        const dropdownVariationUrls = option.data('variationUrls');

        if (!variationAttributeValue) {
            return true;
        }

        if (variationAttributeValue && variationAttributeValues.indexOf(variationAttributeValue) === -1){
            return false;
        }

        const isOptionOutOfStock = variationUrls[variationAttributeValue].isOutOfStock;
        option.data('variationIsAvailable', !isOptionOutOfStock);
        option.attr('out-of-stock', isOptionOutOfStock);
        option.data('variationTitle', dropdownVariationUrls[swatchVariationAttributeValue].title);
        option.text(dropdownVariationUrls[swatchVariationAttributeValue].title + ' (' + dropdownVariationUrls[swatchVariationAttributeValue].price + ')');
        const alreadySelectedValue = $selectedOption.data('variationAttributeValue') === variationAttributeValue;
        const canBeSelected = isFirstPass || true;
        const selected = alreadySelectedValue && canBeSelected;
        option.attr('selected', selected);
        if (selected) {
            selectedOptionValue = option.val();
        }
        return true;
    });

    select.empty().html(items);
    select.data('selectedDropdownValue', selectedOptionValue);
}

function setOutOfStockClass(select){
    const $selectric = select.parents('.selectric-js-pdp-custom-select');
    const $selectricLabel = $('.selectric', $selectric);
    const $dropdown = select.parents('.js-pdp-options-dropdown');
    const $selectedOption = select.children(':selected');
    const isAvailable = $selectedOption.data('variationIsAvailable');

    if (isAvailable == false) {
        $selectricLabel.addClass('out-of-stock');
        $dropdown.addClass('out-of-stock');
        return;
    }

    $selectricLabel.removeClass('out-of-stock');
    $dropdown.removeClass('out-of-stock');
}

function renderSelectricDropdown(select) {
    const $selectric = select.parents('.selectric-js-pdp-custom-select');

    if (!$selectric.length) {
        return;
    }

    const $visibleOptionList = $('.selectric-items ul', $selectric);

    for (let i = 0; i < select.children().length; i++) {
        const $option = $(select.children()[i]);
        const data = $option.data('variationIsAvailable');

        if (data != true && data != false) {
            continue;
        }

        const $visibleOption = $visibleOptionList.find($('[data-index="' + i + '"]'));

        if (data){
            $visibleOption.removeClass('out-of-stock');
        } else {
            $visibleOption.addClass('out-of-stock');
        }
    }
}

function bindValidationEvents(el){
    if (!el.hasClass('js-selectric-validate')) {
        return;
    }

    el.on('change', function() {
        $(this).valid();
        //gtm event for not selecting any value
        if ($(this).hasClass('js-validator-error')) {
            gtm.pushDataLayerEvent({
                'event': 'form_field_error',
                'error_type': 'form_field_error',
                'error_message': $(this).closest('.js-create-account-left-content') && 'wrong gender value, please select a valid value',
                'error_code': null,
                'content_name': $(this).closest('.js-create-account-left-content') && 'register page'
            });
        }

    });
    //Avoid adding multiple events
    el.removeClass('js-selectric-validate');
}


function skipInitialization(el) {
    return el.parents('.selectric-hide-select').length || el.parents('.js-skip-custom-select').length;
}

const customSelect = {
    init: initializeCustomSelect
};

module.exports = customSelect;

$(document).on('selectric.setOutOfStockClass', function (event, select) {
    select = $(select);
    setOutOfStockClass(select);
});

$(document).on('selectric.filterVisibleOptionsAndSetOutOfStockClass', function (event, select) {
    select = $(select);
    filterVisibleOptions(select);
    if (select.parents('.selectric-js-pdp-custom-select').length) {
        select.selectric('refresh');
    } else {
        setOutOfStockClass(select);
    }
});
